module.exports = __webpack_public_path__ + "images/btn-sociallog-apple.png?dda18";